import { graphql } from 'react-relay';

export const baseDataFragment = graphql`
  fragment BaseData_component on BaseData 
  @argumentDefinitions(
    salesAdmission: { type: "String" }
  )
  {
    header
    entries(first: 1000) {
      edges {
        node {
          ... on ItemListEntry {
            value
          }
          ...ItemListEntry_component
        }
      }
    }
    equity {
      ...BaseDataEquity_content
    }
    files(salesAdmission: $salesAdmission) {
      ...FileLink_fileLink
    }
    chart {
      ...BaseDataChart_chart
    }
  }
`;
